import React from "react";
import { useBackofficeUser } from "../../provider/BackofficeUserProvider";
import { Box, Theme } from "@mui/material";
import { Activity } from "../../types/Activity";
import dayjs from "dayjs";
import { isUrgentActivity } from "../../services/Activities/activityFunctions";

const activityInfoStyles = {
  today: (theme: Theme) => ({
    fontWeight: 700,
    color: theme.palette.primary.main,
  }),
  overdue: {
    color: "#ca0d0d",
  },
  todayAndOverdue: {
    color: "#ca0d0d",
    fontWeight: 700,
  },
  spanContainer: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      whiteSpace: "nowrap",
    },
  }),
};

type ActivityInfoProps = {
  activity: Activity<string>;
};

const ActivityInfo = ({ activity }: ActivityInfoProps) => {
  const { getUserData } = useBackofficeUser();

  const getStyle = (activity: Activity, isToday: boolean) => {
    if (isToday && isUrgentActivity(activity)) {
      return activityInfoStyles.todayAndOverdue;
    }
    if (isToday) {
      return activityInfoStyles.today;
    }
    if (isUrgentActivity(activity)) {
      return activityInfoStyles.overdue;
    }
  };

  const isToday = dayjs(activity.dueDate).isSame(dayjs(), "day");
  const dateString = isToday ? "Heute" : dayjs(activity.dueDate).format("DD.MM.YYYY");
  const timeString = activity.dueTime !== "allDay" ? "um " + activity.dueTime + " Uhr" : "";

  return (
    <Box sx={activityInfoStyles.spanContainer}>
      <Box component="span" sx={getStyle(activity, isToday)}>
        {dateString} {timeString}
      </Box>{" "}
      |{" "}
      <Box component={"span"} sx={isUrgentActivity(activity) ? activityInfoStyles.overdue : {}}>
        {getUserData(activity.assignedUser)?.person.fullname ?? "Nicht zugewiesen"}
      </Box>
    </Box>
  );
};

export default ActivityInfo;
